import { render, staticRenderFns } from "./Pendientellegada.vue?vue&type=template&id=54bb04cf&scoped=true&"
import script from "./Pendientellegada.vue?vue&type=script&lang=js&"
export * from "./Pendientellegada.vue?vue&type=script&lang=js&"
import style0 from "./Pendientellegada.vue?vue&type=style&index=0&id=54bb04cf&scoped=true&lang=css&"
import style1 from "./Pendientellegada.vue?vue&type=style&index=1&id=54bb04cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bb04cf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VApp,VBtn,VCard,VCardText,VDataTable,VDialog,VForm,VIcon,VSpacer,VToolbar,VToolbarTitle})
